module.exports = __webpack_public_path__ + "media/images/basic_logos/download-09972a02489a38872257afa7aecbac27.svg";